/**
 * Iniciais estáveis para avatar (nome completo ou e-mail).
 * Evita só a 1ª letra quando há sobrenome — mais reconhecível no header.
 */
export const getInitials = (
  nameOrEmail: string | null | undefined,
  fallback = "SA"
): string => {
  const raw = (nameOrEmail || "").trim();
  if (!raw) {
    return fallback.slice(0, 2).toUpperCase();
  }

  // E-mail: usa a primeira letra local (antes do @).
  if (raw.includes("@")) {
    const local = raw.split("@")[0] || raw;
    return local.charAt(0).toUpperCase();
  }

  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return (
    parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
  ).toUpperCase();
};
